export default "__VITE_ASSET__DOKvjT5S__"